import { SurveyType } from 'src/utils/data/types';

export const flatToTree = (sections, parentPosition = null, type, parentOriginalPosition = null) => {
  return sections
    .map((section, index) => ({
      ...section,
      originalIndex: index,
    }))
    .filter(section => section.parentPosition === parentPosition)
    .map((section, index) => {
      const values = {
        ...section,
        children: flatToTree(sections, section.position, type, index),
        id: section.id,
        name: section.name,
        originalIndex: section.originalIndex,
        parentOriginalPosition,
        parentPosition: section.parentPosition,
        position: index,
        questions: section.questions,
        isQuickActive: section.isQuickActive,
        quickResultId: section.quickResultId,
      };

      if (type === SurveyType.Checklist) {
        values.checklistSectionIdAlias = section.checklistSectionIdAlias;
      }

      return values;
    });
};

export const getSectionNumber = ({
  indexPath,
  parentChecklistSectionIdAlias,
  section,
  type,
}) => {
  if (type === SurveyType.Checklist) {
    const parentIndex = `${indexPath.map(v => v + 1).join('.')}${
      indexPath.length > 0 ? '.' : ''
    }`;

    return `${parentChecklistSectionIdAlias || parentIndex}` +
      `${section.checklistSectionIdAlias || `${section.position + 1}.`}`;
  }

  return `${indexPath.map(v => v + 1).join('.')}${
    indexPath.length > 0 ? '.' : ''
  }${section.position + 1}.`;
};

export const sectionsWithNumbersFlat = (
  sections,
  startPosition = 0,
  parentPosition = null,
  indexPath = [],
  parentChecklistSectionIdAlias = null,
) => {
  let result = [];

  sections.forEach(section => {
    const { children, originalIndex, parentOriginalPosition, ...sectionWithoutChildren } = section;
    const sectionData = { ...sectionWithoutChildren };
    const newIndexPath = sectionData.parentPosition ? [...indexPath] : [];

    if (newIndexPath.length > 0 || sectionData.parentPosition !== null) {
      newIndexPath.push(parentOriginalPosition);
    }

    const sectionNumber = getSectionNumber({
      indexPath: newIndexPath,
      parentChecklistSectionIdAlias,
      section: sectionData,
      type: SurveyType.Checklist
    });

    result = [
      ...result,
      {
        ...sectionWithoutChildren,
        position: startPosition + result.length,
        parentPosition,
        sectionNumber
      },
      ...sectionsWithNumbersFlat(
        children,
        startPosition + result.length + 1,
        startPosition + result.length,
        newIndexPath,
        sectionNumber
      ),
    ];
  });

  return result;
};

export const treeToFlat = (
  sections,
  startPosition = 0,
  parentPosition = null,
) => {
  let result = [];

  sections.forEach(section => {
    const { children, originalIndex, ...sectionWithoutChildren } = section;
    result = [
      ...result,
      {
        ...sectionWithoutChildren,
        position: startPosition + result.length,
        parentPosition,
      },
      ...treeToFlat(
        children,
        startPosition + result.length + 1,
        startPosition + result.length,
      ),
    ];
  });

  return result;
};
